import {
    redirectToPlan,
    redirectToPurchasePayment,
    redirectToPurchasePeriodPaymentPayment,
} from 'businessCommon/src/services';
import './schemeComparison.scss';
import { lang, commonLang, isSystem } from '@umu/ukit-lang';
import React from 'react';
import { ISchemeComparisonDataItem, ITableListItem, IRowListItem } from '@umu/umu-types';
import { schemeComparisonData, trackEvent } from '../../utils/util';
import { setStatLogDialogs } from '@umu/umu-api';
import { If, Button } from 'common/src/components';
import { IPlanInfo, PLAN_TYPE, VERSION_TYPE, IUserInfo } from '@umu/umu-types';

import { ACTION_TYPE, DEVICE_FROM_MAP } from '@umu/umu-api/src/services/payment/paymentEvent';
import { BasicBuyButton, EnterpriseBuyButton, ProfessionalBuyButton } from '../buyButton';
import { OverSticky } from 'common/components/overSticky/overSticky';

interface IVersionItemProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    userInfo?: IUserInfo;
    platform: 'twww' | 'mobile';
}
export const SchemeComparison = (props: IVersionItemProps) => {
    const { isRegisterUser, planInfo, platform } = props;

    const onPlan = (planId: number, isBuyNow?: boolean) => {
        redirectToPlan(platform, isRegisterUser, planId, isBuyNow);
    };

    const redirectInCommerical = () => {
        // 团队版试用
        if (planInfo.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL) {
            redirectToPurchasePayment(platform, PLAN_TYPE.COMMERICAL);
            return;
        }
        redirectToPurchasePeriodPaymentPayment(platform);
        return;
    };

    const getTableTitleList = () => {
        return (
            <OverSticky className="scheme-table-title" position={{ top: '55px' }}>
                <div className="table-title-item"></div>
                <div className="table-title-item">
                    {lang('基本版')}
                    <BasicBuyButton {...props} />
                </div>
                <div className="table-title-item">
                    {lang('专业版')}
                    <ProfessionalBuyButton {...props} />
                </div>
                <div className="table-title-item">
                    {lang('团队版')}
                    <div className="price-button">
                        <If condition={!isRegisterUser || planInfo.plan_id < 3}>
                            <Button
                                onClick={() => {
                                    trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                    onPlan(PLAN_TYPE.COMMERICAL, true);
                                }}
                                className="price-edition-btn"
                                alias="striking"
                            >
                                {commonLang('立即购买')}
                            </Button>
                        </If>
                        <If
                            condition={
                                isRegisterUser &&
                                planInfo.plan_id === 3 &&
                                planInfo.teacher_status === VERSION_TYPE.COMMERICAL
                            }
                        >
                            <Button className="price-edition-btn" alias="striking" onClick={redirectInCommerical}>
                                {commonLang('正在使用')}
                            </Button>
                        </If>
                    </div>
                </div>

                <div className="table-title-item">
                    {lang('企业版')}
                    <EnterpriseBuyButton {...props} />
                </div>
            </OverSticky>
        );
    };

    const onColumnDesClick = (item: IRowListItem) => {
        if (!item.action_type || !item.page_type) {
            return;
        }
        setStatLogDialogs({ page_type: item.page_type, action_type: item.action_type });
    };

    const getTableColumnList = (list: IRowListItem[]) => {
        const ret: JSX.Element[] = [];
        list.map((item: IRowListItem, index: number) => {
            const hasPermission = item.isCheckMark === 1;
            const noPermission = !item.isCheckMark && !item.des;
            ret.push(
                <li className="scheme-table-column" key={index}>
                    <If condition={hasPermission}>
                        <div className="scheme-table-check"></div>
                    </If>
                    <If condition={noPermission}>
                        <div className="scheme-table-check uncheck"></div>
                    </If>
                    <If condition={!hasPermission && !noPermission}>
                        <div className={index === 0 ? 'des' : 'column-des'} onClick={() => onColumnDesClick(item)}>
                            <If condition={!item.href}>
                                <span>{item.des}</span>
                            </If>
                            <If condition={!!item.href}>
                                <a href={item.href} rel="noreferrer" target="_blank">
                                    {item.des}
                                </a>
                            </If>
                        </div>
                    </If>
                </li>,
            );
        });
        return ret;
    };

    const getTableList = (list: ITableListItem[]) => {
        const ret: JSX.Element[] = [];
        list.map((item: ITableListItem, index: number) => {
            if (!item.hide) {
                ret.push(
                    <ul className="scheme-table-row" key={index}>
                        {getTableColumnList(item.rowList)}
                    </ul>,
                );
            }
        });
        return ret;
    };

    const getSchemeTable = (list: ISchemeComparisonDataItem[]) => {
        const ret: JSX.Element[] = [];
        list.map((item: ISchemeComparisonDataItem, index: number) => {
            ret.push(
                <div key={index}>
                    <div className="scheme-table-des">
                        <div className="title">{item.title}</div>
                        <If condition={!isSystem('JP') && index === 0}>
                            <div className="desc">＊ {lang('团队试用版仅包括基本版的互动教学工具功能')}</div>
                        </If>
                    </div>
                    {getTableList(item.tableList)}
                </div>,
            );
        });
        return ret;
    };

    return (
        <div className="scheme-comparison">
            <div className="scheme-comparison-title">{lang('方案对比')}</div>
            <div className="scheme-table-content">
                {getTableTitleList()}
                <div className="scheme-table-list">{getSchemeTable(schemeComparisonData)}</div>
            </div>
        </div>
    );
};
